import { Outlet } from 'react-router-dom'
import { AnalyticsConsentBanner } from './AnalyticsConsentBanner'
import { AppFooter } from './AppFooter'
import { PublicAuthHeader } from './PublicAuthHeader'

export function PublicLayout() {
  return (
    <div className="relative flex min-h-dvh flex-col overflow-x-hidden bg-zinc-50 text-zinc-900 dark:bg-zinc-950 dark:text-zinc-50">
      <div
        className="pointer-events-none fixed inset-0 -z-10 bg-[radial-gradient(ellipse_120%_80%_at_50%_-20%,rgba(139,92,246,0.18),transparent)] dark:bg-[radial-gradient(ellipse_120%_80%_at_50%_-20%,rgba(139,92,246,0.12),transparent)]"
        aria-hidden
      />
      <div
        className="pointer-events-none fixed bottom-0 left-1/2 -z-10 h-[40vh] w-[min(100%,80rem)] -translate-x-1/2 bg-[radial-gradient(circle_at_50%_100%,rgba(99,102,241,0.08),transparent_65%)] dark:bg-[radial-gradient(circle_at_50%_100%,rgba(99,102,241,0.06),transparent_65%)]"
        aria-hidden
      />
      <PublicAuthHeader />
      <main className="flex min-h-0 flex-1 flex-col px-4 py-6 sm:px-6 sm:py-8">
        <Outlet />
      </main>
      <AppFooter />
      <AnalyticsConsentBanner />
    </div>
  )
}
